import React from 'react';
import { useWeather } from '../../context/WeatherContext';
import { Select } from '../ui/Select';
import { openmeteoParameters } from '../../constants/parameters';

export function ParameterSelector() {
  const { modelSelect, parameterSelect, setParameterSelect } = useWeather();

  // Don't show parameter selector for wildfire, drought, or xweather models
  if (modelSelect === 'wildfire' || modelSelect === 'drought' || modelSelect === 'xweather') {
    return null;
  }

  // Only show for OpenMeteo
  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-[var(--secondary-text)] mb-2">
        Parameter
      </label>
      <Select
        value={parameterSelect}
        onChange={(e) => setParameterSelect(e.target.value)}
        options={Object.entries(openmeteoParameters).map(([label, value]) => ({
          value,
          label
        }))}
      />
    </div>
  );
}